import { inject, Injectable } from '@angular/core';
import { Action } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { ADMIN_DEFINITIONS_LOAD, AdminDefinitionsLoadAction, AdminDefinitionsLoadFailAction, AdminDefinitionsLoadSuccessAction } from './admin-definitions.actions';
import { AdminDefinitionRestService } from '../../../services/rest/admin/admin-definition.rest.service';
import { TranslateService } from '@ngx-translate/core';
import { catchError, filter, map, mergeMap, withLatestFrom } from 'rxjs/operators';
import { AuthenticationService } from '../../../authentication/authentication.service';

@Injectable({ providedIn: 'root' })
export class AdminDefinitionsEffects {

  private authenticationService = inject(AuthenticationService);

  loadAdminDefinitions$: Observable<Action> = createEffect(() =>
    this.actions$.pipe(
      ofType<AdminDefinitionsLoadAction>(ADMIN_DEFINITIONS_LOAD),
      withLatestFrom(this.authenticationService.authenticated$, (action, isAuthenticated) => ({
        action,
        isAuthenticated,
      })),
      filter(({ isAuthenticated }: { isAuthenticated: boolean }) => isAuthenticated),
      mergeMap(
        (
          { action, isAuthenticated }: { action: AdminDefinitionsLoadAction; isAuthenticated: boolean } // Register to this event, unregister previous if new event occurs.
        ) =>
          this.adminDefinitionRestService.getAdminDefinitions(action.payload.language).pipe(
            map(
              adminDefinitions =>
                new AdminDefinitionsLoadSuccessAction({
                  adminDefinitions,
                  roles: this.translateService.instant('ADMIN.ROLES'),
                })
            ),
            catchError(err => {
              return of(new AdminDefinitionsLoadFailAction(err));
            })
          )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private adminDefinitionRestService: AdminDefinitionRestService,
    private translateService: TranslateService,
  ) {}
}
